(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["size-color-switcher"] && !Shopify.designMode) return;
  try {
    // Switches are tagged sw=size / sw=color at click time, so GA4 sees them in the page
  // address while the links Google crawls stay clean.
  document.addEventListener('change', (evt) => {
    if (!evt.target.matches('.size-color-switcher__select')) return;
    const url = new URL(evt.target.value, window.location.origin);
    url.searchParams.set('sw', 'size');
    window.location.href = url.pathname + url.search;
  });

  document.addEventListener('click', (evt) => {
    const swatch = evt.target.closest('.size-color-switcher__swatch');
    if (!swatch || swatch.hasAttribute('aria-current')) return;
    const url = new URL(swatch.href, window.location.origin);
    url.searchParams.set('sw', 'color');
    swatch.href = url.pathname + url.search;
  });

  // Back/forward restores the page from memory with the last picked size in the box.
  // Put the box back on this page's own size.
  window.addEventListener('pageshow', () => {
    document.querySelectorAll('.size-color-switcher__select').forEach((select) => {
      const own = Array.from(select.options).find((option) => option.defaultSelected);
      if (own) select.value = own.value;
    });
  });
  } catch(e) { console.error(e); }
})();

})();
